import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  GET_LOGOUT
} from "./actionTypes"
import {
  getLogoutSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* getLogout() {
  try {
    
    const response = yield call(
      makeAjax,
      url.USER_API.logout,
      [],
      url.USER_MS_EXT
    );
    if (response.status == 'SUCCESS') {
      yield all([
        put(getLogoutSuccess({ response: response.data }))
      ]);
    }
    else {
      showMessage(response);
    }
  } catch (error) {
    showMessage(error);
    
    // alert
  }
}

function* logoutSaga() {
  yield takeEvery(GET_LOGOUT, getLogout);
}

export default logoutSaga;
